/* Swubie Landing Page JS */

// Image gallery
function slpSetOfferImage(thumb, url) {
  var mainImg = document.getElementById('slpOfferMainImg');
  if (!mainImg) return;
  mainImg.style.opacity = '0';
  setTimeout(function() { mainImg.src = url; mainImg.style.opacity = '1'; }, 200);
  document.querySelectorAll('.slp-offer__thumb').forEach(function(t) { t.classList.remove('active'); });
  thumb.classList.add('active');
}

// Bundle selection
function slpSelectBundle(el) {
  document.querySelectorAll('.slp-bundle').forEach(function(b) { b.classList.remove('selected'); });
  el.classList.add('selected');
  var input = document.querySelector('.slp-variant-input');
  if (input) input.value = el.getAttribute('data-variant-id');
  slpUpdateAtcButton(el);
}

// Update Add-to-Cart button label/sub based on the selected bundle's pre-order state
function slpUpdateAtcButton(bundle) {
  var btn = document.querySelector('.slp-offer__atc-btn');
  if (!btn || !bundle) return;
  var label = btn.querySelector('.slp-offer__atc-label');
  var sub = btn.querySelector('.slp-offer__atc-sub');
  if (!label || !sub) return;

  var isPreorder = bundle.getAttribute('data-preorder') === 'true';
  var ctaText = btn.getAttribute('data-cta-text') || 'Bestel nu';
  var preorderLabel = btn.getAttribute('data-preorder-label') || 'Pre-order';
  var preorderMsg = btn.getAttribute('data-preorder-message') || '';

  if (isPreorder) {
    label.textContent = preorderLabel;
    sub.textContent = preorderMsg;
    btn.classList.add('is-preorder');
  } else {
    label.textContent = ctaText;
    sub.textContent = preorderMsg; // keep DOM populated; CSS hides when not .is-preorder
    btn.classList.remove('is-preorder');
  }
}

document.addEventListener('DOMContentLoaded', function() {

  // Set initial variant from pre-selected bundle
  var selected = document.querySelector('.slp-bundle.selected');
  var input = document.querySelector('.slp-variant-input');
  if (selected && input) {
    input.value = selected.getAttribute('data-variant-id');
  }

  // Initialize ATC button state for the preselected bundle (or first bundle as fallback)
  var initialBundle = selected || document.querySelector('.slp-bundle');
  if (initialBundle) slpUpdateAtcButton(initialBundle);

  // Intercept form submit
  var form = document.querySelector('.slp-offer__atc-form form');
  if (form) {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      var vid = document.querySelector('.slp-variant-input');
      if (!vid || !vid.value) return;

      var btn = form.querySelector('button');
      var btnLabel = btn.querySelector('.slp-offer__atc-label');
      var btnSub = btn.querySelector('.slp-offer__atc-sub');
      var origLabel = btnLabel ? btnLabel.textContent : btn.textContent;
      var origSub = btnSub ? btnSub.textContent : '';
      var wasPreorder = btn.classList.contains('is-preorder');
      if (btnLabel) {
        btnLabel.textContent = 'Toevoegen...';
      } else {
        btn.textContent = 'Toevoegen...';
      }
      if (btnSub) btnSub.textContent = '';
      btn.classList.remove('is-preorder');
      btn.disabled = true;

      var body = new FormData();
      body.append('id', vid.value);
      body.append('quantity', '1');
      body.append('sections', 'cart-drawer,cart-icon-bubble');

      fetch('/cart/add.js', { method: 'POST', body: body })
        .then(function(r) { return r.json(); })
        .then(function(data) {
          var drawer = document.querySelector('cart-drawer');
          if (drawer && data.sections) {
            // Update drawer inner content (same approach as CartDrawerItems)
            var drawerInner = document.querySelector('#CartDrawer .drawer__inner');
            if (drawerInner && data.sections['cart-drawer']) {
              var parsed = new DOMParser().parseFromString(data.sections['cart-drawer'], 'text/html');
              var newInner = parsed.querySelector('.drawer__inner');
              if (newInner) drawerInner.innerHTML = newInner.innerHTML;
            }

            // Update cart icon bubble
            var iconBubble = document.getElementById('cart-icon-bubble');
            if (iconBubble && data.sections['cart-icon-bubble']) {
              var parsedIcon = new DOMParser().parseFromString(data.sections['cart-icon-bubble'], 'text/html');
              var newIcon = parsedIcon.querySelector('.shopify-section');
              if (newIcon) iconBubble.innerHTML = newIcon.innerHTML;
            }

            // Update footer
            var drawerFooter = document.querySelector('#CartDrawer .drawer__footer');
            if (drawerFooter && data.sections['cart-drawer']) {
              var parsedFooter = new DOMParser().parseFromString(data.sections['cart-drawer'], 'text/html');
              var newFooter = parsedFooter.querySelector('.drawer__footer');
              if (newFooter) drawerFooter.innerHTML = newFooter.innerHTML;
            }

            // Open drawer
            drawer.classList.remove('is-empty');
            drawer.open();
          }

          if (btnLabel) {
            btnLabel.textContent = 'Toegevoegd ✓';
          } else {
            btn.textContent = 'Toegevoegd ✓';
          }
          btn.disabled = false;
          setTimeout(function() {
            if (btnLabel) {
              btnLabel.textContent = origLabel;
            } else {
              btn.textContent = origLabel;
            }
            if (btnSub) btnSub.textContent = origSub;
            if (wasPreorder) btn.classList.add('is-preorder');
          }, 2000);
        })
        .catch(function() {
          window.location = '/cart';
        });
    });
  }

  // Scroll reveal
  var revealEls = document.querySelectorAll('.reveal');
  if (revealEls.length) {
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) entry.target.classList.add('visible');
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
    revealEls.forEach(function(el) { observer.observe(el); });
  }

  // Video testimonials — lazy load video on click, play/pause
  document.querySelectorAll('.slp-videos__card').forEach(function(card) {
    card.addEventListener('click', function() {
      var videoUrl = card.getAttribute('data-video-url');
      if (!videoUrl) return;

      // Pause all other videos
      document.querySelectorAll('.slp-videos__card').forEach(function(other) {
        if (other !== card) {
          var otherVideo = other.querySelector('video');
          if (otherVideo) { otherVideo.pause(); }
          other.classList.remove('playing');
        }
      });

      var video = card.querySelector('video');

      // Create video element on first click
      if (!video) {
        video = document.createElement('video');
        video.src = videoUrl;
        video.playsinline = true;
        video.loop = true;
        video.style.cssText = 'width:100%!important;height:100%!important;object-fit:cover!important;position:absolute;top:0;left:0;z-index:1;';
        card.appendChild(video);
        video.play();
        card.classList.add('playing');
      } else if (video.paused) {
        video.play();
        card.classList.add('playing');
      } else {
        video.pause();
        card.classList.remove('playing');
      }
    });
  });

  // Smooth scroll for anchor links
  document.querySelectorAll('a[href^="#"]').forEach(function(a) {
    a.addEventListener('click', function(e) {
      var target = document.querySelector(this.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

});
